import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import './VideoWithSpinner.css'; 

const VideoWithSpinner = ({ src, ...props }) => {
  const [isLoading, setIsLoading] = useState(true);
  const videoRef = useRef(null);

  const handleWaiting = () => {
    // If the video stops for buffering, show spinner again
    setIsLoading(true);
  };

  const handlePlaying = () => {
    // Once it's actually playing, hide spinner
    setIsLoading(false);
  };

  return (
    <div className="video-container">
      {isLoading && <div className="spinner" />}
      <video
        ref={videoRef}
        onWaiting={handleWaiting}
        onPlaying={handlePlaying}
        {...props}
      >
        <source src={src} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
};

VideoWithSpinner.propTypes = {
  src: PropTypes.string.isRequired,
};

export default VideoWithSpinner;
